import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from "react";
const SvgNetherlands = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512 512",
        style: {
            enableBackground: "new 0 0 512 512"
        },
        xmlSpace: "preserve",
        width: "1em",
        height: "1em",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                style: {
                    fill: "#ff4b55"
                },
                d: "M414.981.5H97.019C42.247 7.823 0 54.725 0 111.5v59.333h512V111.5c0-56.775-42.247-103.677-97.019-111z"
            }),
            /*#__PURE__*/ _jsx("path", {
                style: {
                    fill: "#41479b"
                },
                d: "M0 399.5c0 61.856 50.144 112 112 112h288c61.856 0 112-50.144 112-112v-58.333H0V399.5z"
            }),
            /*#__PURE__*/ _jsx("path", {
                style: {
                    fill: "#f5f5f5"
                },
                d: "M0 170.83h512v170.33H0z"
            })
        ]
    });
export { SvgNetherlands };
